import { ScopedError } from "@captions-web/dev-logger";

export class KnownApiError extends Error {
  constructor(
    message: string,
    public responseStatus: number,
    public errorInfo: { message: string; code?: string; [key: string]: any },
    public responseObject: any
  ) {
    super(message);
    this.name = "KnownApiError";

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, KnownApiError);
    }
  }
}

export class ApiUnavailableError extends Error {
  constructor(
    public responseStatus: number,
    public responseData: any
  ) {
    super("failed api request");
    this.name = "ApiUnavailableError";

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiUnavailableError);
    }
  }
}

export function getErrorTypeFromNetworkError(error: unknown) {
  if (error instanceof KnownApiError) {
    return error.responseObject.errorType;
  }

  if (error instanceof ScopedError) {
    return getErrorTypeFromNetworkError(error.cause);
  }

  return;
}
